(() => {
  const roots = document.querySelectorAll("[data-all-six-booking-beta]");

  function formatDateTime(value) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      weekday: "short",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
    }).format(date);
  }

  function dateInputValue(date) {
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().slice(0, 10);
  }

  function dateRangeForDay(value) {
    const start = new Date(`${value}T00:00:00`);
    const end = new Date(start);
    end.setDate(end.getDate() + 1);
    return {
      startAt: start.toISOString(),
      endAt: end.toISOString(),
    };
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function todayInputValue() {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    while ([0, 6].includes(date.getDay())) {
      date.setDate(date.getDate() + 1);
    }
    return dateInputValue(date);
  }

  roots.forEach((root) => {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const apiBase = (root.dataset.apiBase || "https://client.allsixsalon.com").replace(/\/$/, "");
    const mode = root.dataset.mode || "general";
    const fallbackUrl = root.dataset.fallbackUrl || "https://book.squareup.com/appointments/9y7c9s6jkuvbn9/location/LQ8GWHEH26HC9/services";
    const app = root.querySelector("[data-booking-app]");
    const status = root.querySelector("[data-booking-status]");
    const isHydrafacial = mode === "hydrafacial";
    const state = {
      config: null,
      services: [],
      goals: [],
      team: [],
      selectedGoal: "",
      selectedService: null,
      selectedProvider: "any",
      selectedDate: todayInputValue(),
      slots: [],
      selectedSlot: null,
      loading: false,
      message: "",
      confirmation: null,
    };

    async function api(path, options = {}) {
      const response = await fetch(`${apiBase}${path}`, {
        ...options,
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          ...(options.headers || {}),
        },
      });
      const payload = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(payload.error || payload.message || "Request failed.");
      }

      return payload;
    }

    function setStatus(message, strong = "") {
      if (!status) return;
      status.innerHTML = strong
        ? `<strong>${escapeHtml(strong)}</strong> <span>${escapeHtml(message)}</span>`
        : `<span>${escapeHtml(message)}</span>`;
    }

    function serviceBySlug(slug) {
      return state.services.find((service) => service.slug === slug) || null;
    }

    function selectService(service) {
      state.selectedService = service;
      state.slots = [];
      state.selectedSlot = null;
      render();
    }

    function selectGoal(goal) {
      if (!goal) return;
      state.selectedGoal = goal.slug;
      const service = serviceBySlug(goal.recommendedServiceSlug);
      if (service) {
        selectService(service);
      } else {
        render();
      }
    }

    function selectedServiceFallback() {
      return state.selectedService?.fallbackBookingUrl || state.config?.fallbackBookingUrl || fallbackUrl;
    }

    function selectedProviderLabel() {
      const providerId = state.selectedSlot?.teamMemberId || state.selectedProvider;
      return state.team.find((member) => member.id === providerId)?.label || "Any available provider";
    }

    function previewConfirmation(input = {}) {
      return {
        preview: true,
        service: state.selectedService,
        startsAt: state.selectedSlot?.startAt || "",
        providerLabel: selectedProviderLabel(),
        clientName: input.clientName || "",
        prepNote: "Your selected time is ready to continue through the current booking page.",
        fallbackBookingUrl: selectedServiceFallback(),
        intakeUrl: "https://client.allsixsalon.com/client/intake",
      };
    }

    function renderGoals() {
      if (!isHydrafacial || !state.goals.length) return "";

      return `
        <div class="as-booking-beta__panel">
          <p class="as-booking-beta__label">Goal</p>
          <h2>Choose your skin goal</h2>
          <div class="as-booking-beta__goals">
            ${state.goals.map((goal) => `
              <button class="as-booking-beta__goal" type="button" data-goal="${escapeHtml(goal.slug)}" aria-pressed="${state.selectedGoal === goal.slug}">
                <strong>${escapeHtml(goal.label)}</strong>
                <span>${escapeHtml(serviceBySlug(goal.recommendedServiceSlug)?.title || "Provider-guided recommendation")}</span>
              </button>
            `).join("")}
          </div>
        </div>
      `;
    }

    function renderServices() {
      const services = isHydrafacial
        ? state.services.filter((service) => service.category === "Hydrafacial")
        : state.services;

      return `
        <div class="as-booking-beta__panel">
          <p class="as-booking-beta__label">Service</p>
          <h2>${isHydrafacial ? "Hydrafacial menu" : "Choose a service"}</h2>
          <div class="as-booking-beta__services">
            ${services.map((service) => `
              <button class="as-booking-beta__service" type="button" data-service="${escapeHtml(service.slug)}" aria-pressed="${state.selectedService?.slug === service.slug}">
                <strong>${escapeHtml(service.title)}</strong>
                <span>${escapeHtml([service.category, service.durationMinutes ? `${service.durationMinutes} min` : ""].filter(Boolean).join(" · "))}</span>
                <span>${escapeHtml(service.bestFor || "")}</span>
              </button>
            `).join("")}
          </div>
        </div>
      `;
    }

    function renderWhen() {
      return `
        <div class="as-booking-beta__panel">
          <p class="as-booking-beta__label">Time</p>
          <h2>Find a time</h2>
          <div class="as-booking-beta__controls">
            <label>
              Provider
              <select data-provider>
                ${state.team.map((member) => `
                  <option value="${escapeHtml(member.id)}"${state.selectedProvider === member.id ? " selected" : ""}>${escapeHtml(member.label)}</option>
                `).join("")}
              </select>
            </label>
            <label>
              Date
              <input type="date" data-date value="${escapeHtml(state.selectedDate)}" min="${todayInputValue()}">
            </label>
            <button class="as-booking-beta__button" type="button" data-search ${state.loading || !state.selectedService ? "disabled" : ""}>
              ${state.loading ? "Checking..." : "Search Times"}
            </button>
            <a class="as-booking-beta__link as-booking-beta__link--quiet" href="${escapeHtml(selectedServiceFallback())}">Use current booking</a>
          </div>
          <div class="as-booking-beta__slots" data-slots>
            ${renderSlots()}
          </div>
        </div>
      `;
    }

    function renderSlots() {
      if (!state.selectedService) {
        return '<div class="as-booking-beta__empty">Select a service first.</div>';
      }

      if (state.message) {
        return `<div class="as-booking-beta__notice">${escapeHtml(state.message)}</div>`;
      }

      if (!state.slots.length) {
        return '<div class="as-booking-beta__empty">No times selected yet.</div>';
      }

      return state.slots.map((slot) => `
        <button class="as-booking-beta__slot" type="button" data-slot="${escapeHtml(slot.startAt)}" aria-pressed="${state.selectedSlot?.startAt === slot.startAt}">
          <strong>${escapeHtml(formatDateTime(slot.startAt))}</strong>
          <span>${escapeHtml(slot.teamMemberId ? "Provider time available" : "Available time")}</span>
        </button>
      `).join("");
    }

    function renderDetails() {
      return `
        <div class="as-booking-beta__panel">
          <p class="as-booking-beta__label">Details</p>
          <h2>Your information</h2>
          <form class="as-booking-beta__field-grid" data-details-form>
            <label>
              Name
              <input name="clientName" autocomplete="name" required>
            </label>
            <label>
              Phone
              <input name="clientPhone" autocomplete="tel">
            </label>
            <label>
              Email
              <input name="clientEmail" autocomplete="email" type="email">
            </label>
            <label>
              Notes
              <textarea name="notes" maxlength="500"></textarea>
            </label>
            <button class="as-booking-beta__button" type="submit" ${!state.selectedSlot ? "disabled" : ""}>${state.config?.bookingCreateEnabled ? "Request Booking" : "Review Request"}</button>
            ${state.config?.bookingCreateEnabled === false ? `
              <p class="as-booking-beta__help">Direct confirmation stays on the current booking page while this on-site flow is reviewed.</p>
            ` : ""}
          </form>
        </div>
      `;
    }

    function renderSummary() {
      const service = state.selectedService;
      return `
        <aside class="as-booking-beta__aside" aria-label="Booking summary">
          <div class="as-booking-beta__summary">
            <div class="as-booking-beta__summary-row">
              <span>Service</span>
              <strong>${escapeHtml(service?.title || "Not selected")}</strong>
              <small>${escapeHtml(service?.includes || "")}</small>
            </div>
            <div class="as-booking-beta__summary-row">
              <span>Best for</span>
              <strong>${escapeHtml(service?.bestFor || "Choose a service to see details")}</strong>
            </div>
            <div class="as-booking-beta__summary-row">
              <span>Provider</span>
              <strong>${escapeHtml(selectedProviderLabel())}</strong>
            </div>
            <div class="as-booking-beta__summary-row">
              <span>Time</span>
              <strong>${escapeHtml(formatDateTime(state.selectedSlot?.startAt) || "Not selected")}</strong>
            </div>
            ${service?.askYourProviderIf ? `
              <div class="as-booking-beta__notice">${escapeHtml(service.askYourProviderIf)}</div>
            ` : ""}
          </div>
        </aside>
      `;
    }

    function renderConfirmation() {
      const fallback = state.confirmation?.fallbackBookingUrl || selectedServiceFallback();
      const service = state.confirmation?.service || state.selectedService;
      const startsAt = state.confirmation?.startsAt || state.selectedSlot?.startAt || "";

      return `
        <div class="as-booking-beta__panel">
          <p class="as-booking-beta__label">${state.confirmation?.preview ? "Ready" : "Confirmed"}</p>
          <h2>${state.confirmation?.preview ? "Your visit is ready to finish." : "Request received"}</h2>
          <p class="as-booking-beta__intro">${escapeHtml(state.confirmation?.prepNote || "All Six will review the booking details.")}</p>
          <div class="as-booking-beta__confirmation-list">
            <div>
              <span>Service</span>
              <strong>${escapeHtml(service?.title || "")}</strong>
            </div>
            <div>
              <span>Time</span>
              <strong>${escapeHtml(formatDateTime(startsAt))}</strong>
            </div>
            <div>
              <span>Provider</span>
              <strong>${escapeHtml(state.confirmation?.providerLabel || selectedProviderLabel())}</strong>
            </div>
          </div>
          <div class="as-booking-beta__actions">
            <a class="as-booking-beta__link" href="${escapeHtml(fallback)}">Continue on current booking</a>
            <button class="as-booking-beta__button as-booking-beta__button--quiet" type="button" data-reset-request>Choose another time</button>
            ${state.confirmation?.preview ? "" : `<a class="as-booking-beta__link as-booking-beta__link--quiet" href="${escapeHtml(state.confirmation?.intakeUrl || "https://client.allsixsalon.com/client/intake")}">Open intake</a>`}
          </div>
        </div>
      `;
    }

    function render() {
      if (!app) return;

      if (state.config?.enabled && state.config?.squareConfigured) {
        setStatus("Availability is read from Square when mapped services are configured.", "Beta ready");
      } else {
        setStatus("Current booking remains the fallback while Square beta mapping is completed.", "Safe mode");
      }

      app.innerHTML = state.confirmation
        ? `<div class="as-booking-beta__grid"><main class="as-booking-beta__main">${renderConfirmation()}</main>${renderSummary()}</div>`
        : `
          <div class="as-booking-beta__grid">
            <main class="as-booking-beta__main">
              ${renderGoals()}
              ${renderServices()}
              ${renderWhen()}
              ${renderDetails()}
            </main>
            ${renderSummary()}
          </div>
        `;
    }

    async function load() {
      setStatus("Loading booking options...");

      try {
        const [config, services, team] = await Promise.all([
          api("/api/public/booking/config"),
          api("/api/public/booking/services"),
          api("/api/public/booking/team"),
        ]);
        state.config = config;
        state.services = services.services || [];
        state.goals = services.guidedGoals?.length ? services.guidedGoals : (config.hydrafacialGoals || []);
        state.team = team.team || [{ id: "any", label: "Any available provider" }];
        state.selectedService = state.services.find((service) => isHydrafacial ? service.category === "Hydrafacial" : true) || null;
        render();
      } catch (error) {
        state.message = error.message;
        setStatus(error.message, "Booking unavailable");
        render();
      }
    }

    async function searchAvailability() {
      if (!state.selectedService || !state.selectedDate) return;
      state.loading = true;
      state.message = "";
      state.slots = [];
      state.selectedSlot = null;
      render();

      try {
        const range = dateRangeForDay(state.selectedDate);
        const result = await api("/api/public/booking/availability", {
          method: "POST",
          body: JSON.stringify({
            serviceSlug: state.selectedService.slug,
            teamMemberId: state.selectedProvider,
            ...range,
          }),
        });
        state.slots = result.slots || [];
        state.message = result.available ? "" : (result.message || result.error || "No beta availability is available for that date.");
      } catch (error) {
        state.message = error.message;
      } finally {
        state.loading = false;
        render();
      }
    }

    async function submitBooking(form) {
      if (!state.selectedService || !state.selectedSlot) return;
      const data = new FormData(form);
      const clientName = String(data.get("clientName") || "").trim();
      const clientEmail = String(data.get("clientEmail") || "").trim();
      const clientPhone = String(data.get("clientPhone") || "").trim();

      if (!clientName || (!clientEmail && !clientPhone)) {
        state.message = "Name and either phone or email are required.";
        render();
        return;
      }

      state.loading = true;
      render();

      if (state.config?.bookingCreateEnabled === false) {
        state.confirmation = previewConfirmation({
          clientName,
          clientEmail,
          clientPhone,
        });
        state.loading = false;
        render();
        return;
      }

      try {
        const result = await api("/api/public/booking/create", {
          method: "POST",
          headers: {
            "idempotency-key": crypto.randomUUID ? crypto.randomUUID() : String(Date.now()),
          },
          body: JSON.stringify({
            serviceSlug: state.selectedService.slug,
            startAt: state.selectedSlot.startAt,
            teamMemberId: state.selectedSlot.teamMemberId || state.selectedProvider,
            clientName,
            clientEmail,
            clientPhone,
            notes: String(data.get("notes") || "").trim(),
          }),
        });

        if (!result.booked) {
          state.confirmation = previewConfirmation({
            clientName,
            clientEmail,
            clientPhone,
          });
          state.message = "";
          render();
          return;
        }

        state.confirmation = result.confirmation;
        render();
      } catch (error) {
        state.message = error.message;
        render();
      } finally {
        state.loading = false;
      }
    }

    root.addEventListener("click", (event) => {
      const goalButton = event.target.closest("[data-goal]");
      const serviceButton = event.target.closest("[data-service]");
      const slotButton = event.target.closest("[data-slot]");
      const searchButton = event.target.closest("[data-search]");
      const resetButton = event.target.closest("[data-reset-request]");

      if (goalButton) {
        selectGoal(state.goals.find((goal) => goal.slug === goalButton.dataset.goal));
      }

      if (serviceButton) {
        selectService(serviceBySlug(serviceButton.dataset.service));
      }

      if (slotButton) {
        state.selectedSlot = state.slots.find((slot) => slot.startAt === slotButton.dataset.slot) || null;
        render();
      }

      if (searchButton) {
        searchAvailability();
      }

      if (resetButton) {
        state.confirmation = null;
        render();
      }
    });

    root.addEventListener("change", (event) => {
      if (event.target.matches("[data-provider]")) {
        state.selectedProvider = event.target.value;
        state.slots = [];
        state.selectedSlot = null;
        render();
      }

      if (event.target.matches("[data-date]")) {
        state.selectedDate = event.target.value;
        state.slots = [];
        state.selectedSlot = null;
        render();
      }
    });

    root.addEventListener("submit", (event) => {
      if (event.target.matches("[data-details-form]")) {
        event.preventDefault();
        submitBooking(event.target);
      }
    });

    load();
  });
})();
